type IconFacebookProps = React.ComponentProps<"svg">;

export const IconFacebook: React.FC<IconFacebookProps> = (props) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.1163 0.598633C4.52926 0.598633 0 5.12789 0 10.7149C0 15.459 3.26634 19.44 7.67259 20.5334V13.8064H5.58661V10.7149H7.67259V9.3828C7.67259 5.93962 9.2309 4.34368 12.6114 4.34368C13.2523 4.34368 14.3582 4.46953 14.8106 4.59497V7.39718C14.5719 7.37209 14.1571 7.35954 13.642 7.35954C11.9833 7.35954 11.3424 7.98797 11.3424 9.62154V10.7149H14.6468L14.079 13.8064H11.3424V20.7571C16.3515 20.1522 20.233 15.8872 20.233 10.7149C20.2326 5.12789 15.7033 0.598633 10.1163 0.598633Z"
        fill="currentColor"
      />
    </svg>
  );
};

IconFacebook.displayName = "IconFacebook";
